var render = function render(){var _vm=this,_c=_vm._self._c;return _c('abbr',_vm._b({class:{ 'tooltip': _vm.useTooltip }},"abbr",_vm._d({},[_vm.tooltipMethod,_vm.formatted])),[_vm._v(_vm._s(_vm.fromNow))])
}
var staticRenderFns = []

export { render, staticRenderFns }